import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shTruncate',
  standalone: true,
})
export class TruncatePipe implements PipeTransform {
  transform(value: string, limit: number): string {
    if (limit <= 0 || value === null || value === undefined) return value;

    // 2024-04-26 JV: Can't assume that the input is a string
    const str = value.toString();
    if (str.length <= limit) {
      return value;
    }

    // If the string is at most 3 characters over the limit, return the original value
    if (str.length - limit <= 3) {
      return value;
    }

    // Only add ... if there are more than 3 characters over the limit
    return str.slice(0, limit) + '...';
  }
}
